import { LoadState } from "../../../constants/enums";

export interface ISeedBalanceRow {
  seed_code: string | null;
  fiscal_years_code: string | null;
  // null fiscal_year_month_code represents the "Year Open" column
  fiscal_year_month_code: string | null;
  gl_account_code: string | null;
  branch_code: string | null;
  entered_balance: number | null;
  previous_entered_balance: number | null;
  movement: number | null;
  adjust_mode: string | null;
  status: string | null;
  created_by_name: string | null;
  create_ts: string | null;
}

export interface ISeedCellInput {
  gl_account_code: string;
  // null targets the "Year Open" column
  fiscal_year_month_code: string | null;
  value: number;
}

export interface ISeedSaveResponse {
  saved: number;
  posted: number;
  failed: number;
  period_closed?: boolean;
  retained_earnings_blocked?: boolean;
}

/**
 * A single CSV parse error returned by the server-side importer when the
 * uploaded `csv_content` fails validation (posted === false). The exact fields
 * beyond a human-readable message are best-effort — the server may include a
 * row/column/detail to help the user locate the problem in their file.
 */
export interface ISeedImportParseError {
  row?: number;
  column?: string;
  gl_account_code?: string;
  fiscal_year_month_code?: string | null;
  message?: string;
  reason?: string;
}

/**
 * Response of POST /accounting/seed-balances/import.
 *
 * Two shapes keyed by `posted`:
 *  - Invalid CSV: `{ parsed, cells_ready, parse_errors[], posted: false }`
 *    — nothing was written; the user must fix the file and re-upload.
 *  - Clean CSV:   `{ parsed, cells_ready, posted: true, save: {...} }`
 *    — the parsed cells were persisted via the normal save path.
 */
export interface ISeedImportResponse {
  parsed: number;
  cells_ready: number;
  posted: boolean;
  parse_errors?: ISeedImportParseError[];
  save?: ISeedSaveResponse;
  period_closed?: boolean;
  retained_earnings_blocked?: boolean;
}

export interface ISeedBalancesState {
  grid: ISeedBalanceRow[];
  history: ISeedBalanceRow[];
  loading: LoadState;
  saveLoading: LoadState;
  historyLoading: LoadState;
  error: string | null;
}

export const initialSeedBalancesState: ISeedBalancesState = {
  grid: [],
  history: [],
  loading: LoadState.NotLoaded,
  saveLoading: LoadState.NotLoaded,
  historyLoading: LoadState.NotLoaded,
  error: null,
};
